<template>
  <Layout hide-route-header>
    <Card extra-classes="max-w-lg mx-auto">
      <div id="calendly-embed" ref="calendlyEmbed" style="min-width: 320px; height: 700px" class="mb-12"></div>

      <div class="mt-4">
        <TButton @click="scheduleKickoffCall">
          <vue-feather type="check" class="w-4 h-4 mr-2" />
          Mark completed
        </TButton>
      </div>
    </Card>
  </Layout>
</template>

<script>
import Layout from '../../components/Layout/index.vue';
import Card from '../../components/Card/index.vue';
import TButton from '../../components/shared/TButton.vue';
import { hFetch } from '../../api/hFetch';

export default {
  components: {
    Layout,
    Card,
    TButton,
  },
  data() {
    return {
      loadedCalendly: false,
    };
  },
  mounted() {
    console.log('we mounted');
    console.log(this.$refs.calendlyEmbed);
    console.log(this.loadedCalendly);
    setTimeout(() => {
      if (!this.loadedCalendly && this.$refs.calendlyEmbed) {
        console.log('we are loading the calendly widget');
        Calendly.initInlineWidget({
          url: 'https://calendly.com/d/y3y-r6z-668/humaniz-onboarding?hide_event_type_details=1&hide_gdpr_banner=1',
          parentElement: this.$refs.calendlyEmbed,
          prefill: {
            name: `${this.$store.state.general.currentUser.firstName} ${this.$store.state.general.currentUser.lastName}`,
            email: this.$store.state.general.currentUser.email,
          },
        });
        this.loadedCalendly = true;
      }
    }, 1000);
  },
  methods: {
    async scheduleKickoffCall() {
      const data = await hFetch({
        url: '/api/quickstart/scheduled_kickoff_calls',
        method: 'POST',
        payload: {
          scheduled_kickoff_call: true,
        },
      });

      if (data.success) {
        this.$router.push('/');
      }
    },
  },
};
</script>
